module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "helpList",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "help-search-wp"
  }, [_c('div', {
    staticClass: "clear-fix wh1200"
  }, [_c('div', {
    staticClass: "help-wp2-search"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "试试搜索关键词"
    },
    model: {
      value: (_vm.searchForm),
      callback: function($$v) {
        _vm.searchForm = $$v
      },
      expression: "searchForm"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "wh1200 help-wp6"
  }, [_c('el-col', {
    class: {
      'isFixed': !_vm.isOnTop
    },
    attrs: {
      "span": 5,
      "id": "fixedBar"
    }
  }, [_c('div', {
    staticClass: "clear-fix help-wp5 help-left1"
  }, [_c('div', {
    staticClass: "help-left-wp"
  }, [_c('h2', {
    staticClass: "help-left-title"
  }, [_vm._v("帮助中心")]), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("委托管理")]), _vm._v(" "), _c('ul', {
    staticClass: "help-left-ul1"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('1_1')
      }
    }
  }, [_vm._v("委托业务简介")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('1_2')
      }
    }
  }, [_vm._v("委托订单列表")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('1_3')
      }
    }
  }, [_vm._v("租赁收入列表")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('1_4')
      }
    }
  }, [_vm._v("出售收入列表")])])])], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "租赁管理"
    }
  }, [_c('ul', {
    staticClass: "help-left-ul1"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('2_1')
      }
    }
  }, [_vm._v("租赁业务简介")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('2_2')
      }
    }
  }, [_vm._v("租赁订单查询")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('2_3')
      }
    }
  }, [_vm._v("租赁价格查询")])])])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "库存查询"
    }
  }, [_c('ul', {
    staticClass: "help-left-ul1"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('3_1')
      }
    }
  }, [_vm._v("委托库查询")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('3_2')
      }
    }
  }, [_vm._v("代管库查询")])])])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "维修查询"
    }
  }, [_c('ul', {
    staticClass: "help-left-ul1"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('4_1')
      }
    }
  }, [_vm._v("维修业务简介")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('4_2')
      }
    }
  }, [_vm._v("维修下单列表")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('4_3')
      }
    }
  }, [_vm._v("维修价格查询")])])])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "物流信息查询"
    }
  }, [_c('ul', {
    staticClass: "help-left-ul1"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('5_1')
      }
    }
  }, [_vm._v("发货单列表")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('5_2')
      }
    }
  }, [_vm._v("物流信息列表")])])])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "财务查询"
    }
  }, [_c('ul', {
    staticClass: "help-left-ul1"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('6_1')
      }
    }
  }, [_vm._v("委托收益报表")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('6_2')
      }
    }
  }, [_vm._v("委托销售报表")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('6_3')
      }
    }
  }, [_vm._v("维修支出报表")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('6_4')
      }
    }
  }, [_vm._v("物流支出报表")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('6_5')
      }
    }
  }, [_vm._v("租赁支出报表")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('6_6')
      }
    }
  }, [_vm._v("保证金报表")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('6_7')
      }
    }
  }, [_vm._v("代管库支出报表")])])])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "订单管理"
    }
  }, [_c('ul', {
    staticClass: "help-left-ul1"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('7_1')
      }
    }
  }, [_vm._v("发货通知单")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('7_2')
      }
    }
  }, [_vm._v("采购询价单")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('7_3')
      }
    }
  }, [_vm._v("委托申请单")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('7_4')
      }
    }
  }, [_vm._v("调度申请单")])])])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "个人中心"
    }
  }, [_c('ul', {
    staticClass: "help-left-ul1"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('8_1')
      }
    }
  }, [_vm._v("公司信息")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('8_2')
      }
    }
  }, [_vm._v("服务网点维护")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('8_3')
      }
    }
  }, [_vm._v("工程师信息维护")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHelp('8_4')
      }
    }
  }, [_vm._v("在线反馈")])])])])], 1)], 1)])]), _vm._v(" "), _c('el-col', {
    class: {
      'FixedRightBox': !_vm.isOnTop
    },
    attrs: {
      "span": 19
    }
  }, [(_vm.resultForm.length == 0) ? _c('div', {
    staticClass: "clear-fix help-wp5-bg help-right1"
  }, [_c('h3', {
    staticClass: "help-right1-title2"
  }, [_vm._v("抱歉，没有找到“"), _c('span', [_vm._v(_vm._s(_vm.SearchWords))]), _vm._v("”的内容")]), _vm._v(" "), _c('div', {
    staticClass: "help-no-text"
  }, [_c('p', [_vm._v("我们建议您：")]), _vm._v(" "), _c('p', [_vm._v("· 查看输入的文字是否正确；")]), _vm._v(" "), _c('p', [_vm._v("· 还未解决，可以尝试下面的方式与我们联系。")])])]) : _c('div', {
    staticClass: "clear-fix help-wp5 help-right1"
  }, [(_vm.SearchWords) ? _c('div', [_c('h3', {
    staticClass: "help-right1-title2"
  }, [_vm._v("关于“"), _c('span', [_vm._v(_vm._s(_vm.SearchWords))]), _vm._v("”的搜索结果  共 "), _c('strong', [_vm._v(_vm._s(_vm.resultForm.length))]), _vm._v(" 条")])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('1_1')) ? _c('div', [_c('h4', {
    staticClass: "pt-10",
    attrs: {
      "id": "o-help1"
    }
  }, [_vm._v("一、委托业务简介")]), _vm._v(" "), _c('p', [_vm._v("(1)、合作库是对接行业（国内、外客户）的配件需求的平台，能快速帮助用户实际价值转化，委托业务介绍如下：")]), _vm._v(" "), _c('table', {
    staticClass: "table-01"
  }, [_c('colgroup', [_c('col')]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', [_vm._v("委托业务")]), _vm._v(" "), _c('th', [_vm._v("委托销售")]), _vm._v(" "), _c('th', [_vm._v("委托租赁")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("结算方式")]), _vm._v(" "), _c('td', [_vm._v("售出即结算（数据同步）")]), _vm._v(" "), _c('td', [_vm._v("租期结束即结算（数据同步）")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("结算金额")]), _vm._v(" "), _c('td', [_vm._v("委托价格=结算金额")]), _vm._v(" "), _c('td', [_vm._v("租赁价格分成")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("费用（委托代管）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("免费")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("品质（委托加入）")]), _vm._v(" "), _c('td', [_vm._v("≥七成新")]), _vm._v(" "), _c('td', [_vm._v("①原装全新   ②八成新")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("品质（退还）")]), _vm._v(" "), _c('td', [_vm._v("按验收入库的同等品质")]), _vm._v(" "), _c('td', [_vm._v("①九五成新装   ②≥七成新")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("锁定期")]), _vm._v(" "), _c('td', [_vm._v("≥3个月")]), _vm._v(" "), _c('td', [_vm._v("≥3个月（以租赁合同为准）")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("物流费用（委托加入与退还）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("发货方承担")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("库管特点")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("共享库")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("服务特点")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("合作库提供免费委托产品仓储、专业管理与运营服务")])])])]), _vm._v(" "), _c('p', [_vm._v("(2)、委托业务流程")]), _vm._v(" "), _c('p', [_vm._v("1>了解委托业务--》联系客服或业务员--》提交委托清单---》委托报价确认---》发货---》二次确认--》上线销售（用户在了解进度）")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../assets/menu_img6.jpg"),
      "alt": "委托业务流程"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('1_2')) ? _c('div', [_c('h4', {
    staticClass: "pt-10",
    attrs: {
      "id": "o-help2"
    }
  }, [_vm._v("二、委托订单列表")]), _vm._v(" "), _c('p', [_vm._v("已达成的产品委托业务在订单“委托订单列表展示查询。")]), _vm._v(" "), _c('p', [_vm._v("1>.点击首页标题“委托查询”，选择“委托订单列表”进入委托订单管理；2>.输入：物料名称、委托订单、委托类型、区域等内容任义条件了解委托订单的情况（图1），或通过选择“委托方待发货、受托方处理中、已完成”了解委托物料的状态展示(图2)。")]), _vm._v(" "), _c('div', {
    staticClass: "pt-10"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/help-img1.jpg"),
      "alt": "委托订单"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pt-10"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/help-img2.jpg"),
      "alt": "委托订单"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('1_3')) ? _c('div', [_c('h4', {
    staticClass: "pt-10",
    attrs: {
      "id": "o-help3"
    }
  }, [_vm._v("三、租赁收入列表")]), _vm._v(" "), _c('p', [_vm._v("租赁收入列表是指委托产品通过平台租赁给第三方的收入所得，展示信息包含已结算、待结算的业务信息。")]), _vm._v(" "), _c('p', [_vm._v("1>点击“委托查询”选择“租赁收入列表”能了解委托产品租赁的收入情况。")]), _vm._v(" "), _c('p', [_vm._v("2>.过输入：物料名称、品牌、机型…… 区域等内容任义条件查询委托产品租赁收入情况；或通过选择“委托方待发货、受托方处理中、已完成”了解委托物料的状态展示。")]), _vm._v(" "), _c('div', {
    staticClass: "pt-10"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/help-img3.jpg"),
      "alt": "委托订单"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("3>.用户选择：租赁中、待收款、已收款等选项清楚了解委托产品的租赁结算状态，单一产品查询可点击“查看相关详情”了解详细的业务数据。")]), _vm._v(" "), _c('div', {
    staticClass: "pt-10"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/help-img4.jpg"),
      "alt": "委托订单"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('1_4')) ? _c('div', [_c('h4', {
    staticClass: "pt-10",
    attrs: {
      "id": ""
    }
  }, [_vm._v("四、出售收入列表")]), _vm._v(" "), _c('p', [_vm._v("出售收入列表是指委托平台销售卖出的收入所得，这里展示的是销售订单已结算和待付款的业务信息。")]), _vm._v(" "), _c('p', [_vm._v("1>点击“委托查询”选择“出售收入列表”查询所有委托产品的出售收入情况；")]), _vm._v(" "), _c('p', [_vm._v("2>.快速单个产品结果查询方法：输入物料名称、品牌、机型…… 区域等条件筛选详细的收入；")]), _vm._v(" "), _c('p', [_vm._v("3>.选择：待收款、已收款等选项清楚了解委托产品的结算状态，单一产品查询可点击“查看相关详情”了解详细的业务数据。")]), _vm._v(" "), _c('div', {
    staticClass: "pt-10"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/help-img5.jpg"),
      "alt": "委托订单"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('2_1')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("一、租赁业务简介")]), _vm._v(" "), _c('p', [_vm._v("(1)、租赁业务共享配件模式，相对传统采购配件能降低运营成本和人工成本，减少固定资产投入，配套购买维修、代管业务，一站式解决配件、维修、采购、物流等运营问题。")]), _vm._v(" "), _c('table', {
    staticClass: "table-01",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2",
      "scope": "row"
    }
  }, [_vm._v("租赁方式")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("固定租期")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("灵活租期")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("产品裸租")]), _vm._v(" "), _c('td', [_vm._v("租赁保修价")]), _vm._v(" "), _c('td', [_vm._v("产品裸租")]), _vm._v(" "), _c('td', [_vm._v("租赁保修价")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("租期")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("6个月，12个月，18个月随意选择")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("以3个月为基准随意选择")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("是否保修")]), _vm._v(" "), _c('td', [_vm._v("否")]), _vm._v(" "), _c('td', [_vm._v("是（提供相应租期的保修）")]), _vm._v(" "), _c('td', [_vm._v("否")]), _vm._v(" "), _c('td', [_vm._v("是（提供相应租期的保修）")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("是否能调整租期/产品")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "2",
      "scope": "row"
    }
  }, [_vm._v("调整方式")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("提前15天")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("提前1个月")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("产品增加和延长：增加提交《租赁订单）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("提出（租赁产品增加/减少、租期延长/缩短）调整需求")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("保证金")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("租赁产品报价额的30%")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("租金结算方式")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("按季度结算（租金含6%增值税服务性发票）")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("租赁产品退还"), _c('br'), _vm._v("\n                                      （请参考合作库品项标准）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("一、租赁产品为八成新的产品退回情况："), _c('br'), _vm._v("\n                                      ● 原物退还（带完整条码和防伪标识）,无费用；"), _c('br'), _vm._v("\n                                      ● 非原物退还同等同质,配件完整,损耗类组件成色无要求的,无费用；"), _c('br'), _vm._v("\n                                      ● 非原物退还,品相低于7成新,配件完整,扣抵3个月租金；"), _c('br'), _vm._v("\n                                      ● 不完整配件退还,估值核算,按照6~12个月租赁费用扣抵）;"), _c('br'), _vm._v("\n                                      ● 产品损失,无产品退还；（按照18个月租赁费用扣抵）。"), _c('br'), _vm._v("\n                                      二、租赁产品为原装全新的产品退回情况："), _c('br'), _vm._v("\n                                      ● 同等同质,配件完整,损耗类组件成色无要求,无费用；"), _c('br'), _vm._v("\n                                      ● 非同等同质,九五成新以上,配件完整可正常使用,损耗类组件成色无要求,无费用；"), _c('br'), _vm._v("\n                                      ● 非同等同质,低于九五成新,配件完整,损耗类组件成色无要求,（根据产品成色差异，按照3~12个月租赁费用扣抵）；"), _c('br'), _vm._v("\n                                      ● 不完整配件退还；估值核算,按照6~12个月租赁费用扣抵）;"), _c('br'), _vm._v("\n                                      ● 产品损失,无产品退还；（按照18个月租赁费用扣抵）。")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("产品延期退还"), _c('br'), _vm._v("\n                                      收费标准")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("1.超过一周不到一月的按租赁协议的月费用收取。"), _c('br'), _vm._v("\n                                      2.超过一月不到两月或两个月整的按两个月收取。"), _c('br'), _vm._v("\n                                      3.超过三个月未退回的租赁配件,作配件遗失按照18个月租赁费用收取。")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("保证金退还")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("合同结束后结清合同期的相应帐务后,7个工作日内退还")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("合作库其它有偿服务任选")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("租赁产品委托仓储代管、物料配送、技术维修等一站式服务。")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("增值服务")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("1.运营数据查询、调拨、管理；   2.大数据业务、行业、成本分析数据推送。")])])])]), _vm._v(" "), _c('p', [_vm._v("(2)、租赁业务流程")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/menu_img7.png"),
      "alt": "委托业务流程"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('2_2')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("二、租赁订单查询")]), _vm._v(" "), _c('p', [_vm._v("(1)、租赁订单管理：所有发生租赁业务的订单在\"租赁订单列表”均能展示查询，数据清晰便于管控。")]), _vm._v(" "), _c('p', [_vm._v("具体操作如下：1>点击“租赁查询”选择“租赁订单查询”展示所有租赁订单的状态，查看单一产品或单一订单的租赁情况，通过查询选项：物料名称、租赁订单、订单类型、客户合同编号等条件体现相应的订单内容。")]), _vm._v(" "), _c('div', {
    staticClass: "pt-10"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/zl-img1.jpg"),
      "alt": "租赁管理"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("2>.点击红色框内的：全部、待发货、部份发货、已完成、已取消等选项，查看租赁订单的完成情况。")]), _vm._v(" "), _c('div', {
    staticClass: "pt-10"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/zl-img2.jpg"),
      "alt": "租赁管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("3>.租赁订单的管理，如售后维修、延长租赁时间或合同到期后的退还等，只需点击相应的业务选项对应的产品批次号，退可提交业务申请。")]), _vm._v(" "), _c('div', {
    staticClass: "pt-10"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/zl-img3.jpg"),
      "alt": "租赁管理"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('2_3')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("三、租赁询价查询")]), _vm._v(" "), _c('p', [_vm._v("1>.租赁价格查询：点击“租赁查询”选择“租赁价格查询”，输入需要租赁的产品：品牌、机型、模块、品项、物料名称等单选或多选条件快速查询租赁的价格；")]), _vm._v(" "), _c('div', {
    staticClass: "pt-10"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/zl-img4.jpg"),
      "alt": "租赁管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("2>.或直接点击“新建租赁订单”查询价格或提出租赁申请。（这里也可以新建采购申请单）")]), _vm._v(" "), _c('div', {
    staticClass: "pt-10"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/zl-img5.jpg"),
      "alt": "租赁管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("3>提交“租赁申请单”前，请选择对应的发货方式、订单类型、联系人及联系方式地址、产品品项、租赁期限、维修服务期限等主要选项，备注产品租赁申请的特殊需求，点击“提交并等待客户确认”即成功提交“租赁申请单。后台工作人员会即时处理并与您确认联系。")]), _vm._v(" "), _c('div', {
    staticClass: "pt-10"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/zl-img6.jpg"),
      "alt": "租赁管理"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('3_1')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("一、委托库查询")]), _vm._v(" "), _c('p', [_vm._v("委托产品库存是指合作库平台共享开放给全部用户的产品库存，产品状态分：可租可售、只售、只租等情况，用户可根据自身业务需求（租赁、采购）选择对应的产品，提交业务申请。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/kc-img1.jpg"),
      "alt": "库存查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('3_2')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("一、代管库查询")]), _vm._v(" "), _c('p', [_vm._v("代管库是用户委托平台代为管理的产品，产品包含用户自己的产品和从合作库平台租赁的产品，用户登录后在线设置安全库存数据与适时自主调拨管理。")]), _vm._v(" "), _c('p', [_vm._v("1> 点击“库存查询”选择代管库查询代管总库存、租赁代管库、自有代管库等产品的详细情况；")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/kc-img2.jpg"),
      "alt": "库存查询"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("2>为达到库存的合理化管理，减少资产积压，可以通过设置安全库存的“上下限设置”，设置后系统会根据调拨使用情况自动提示，便捷更智能化的管理库存。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/kc-img3.jpg"),
      "alt": "库存查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('4_1')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("一、维修业务简介")]), _vm._v(" "), _c('p', [_vm._v("(1)、合作库平台维修中心为用户提供多品牌多种机型的维修支持，包含基础维修和日立、OKI核心模块（机芯、验钞模块、EPP模块）的高端维修。")]), _vm._v(" "), _c('p', [_vm._v("(2)、维修业务操作流程")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/menu_img8.png"),
      "alt": "维修查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('4_2')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("二、维修订单列表")]), _vm._v(" "), _c('p', [_vm._v("1>点击“维修查询”选择“维修订单列表”即可管理查询所以维修订单的状态。查看方式可以输入“条件”查询，或选择订单的状态查询（待收货、待质检、待复核……等）")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/wx-img1.jpg"),
      "alt": "维修查询"
    }
  })]), _vm._v(" "), _c('p', {}, [_vm._v("2>单个产品的维修详细状态可点击“查看”")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/wx-img2.jpg"),
      "alt": "维修查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('4_3')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("三、维修询价查询")]), _vm._v(" "), _c('p', [_vm._v("(1)、维修价格查询：")]), _vm._v(" "), _c('p', [_vm._v("点击“维修查询”选择“维修价格查询”即可查询配件的标准维修价格，故障维修要按故障问题点报价，用户可选择快捷上或点击“新建维修单”在线录入信息后提交维修申请单。由后台客服回复处理。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/wx-img3.jpg"),
      "alt": "维修查询"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("(2)、维修下单：")]), _vm._v(" "), _c('p', [_vm._v("1>.点击新建修修单，录入需要维修的产品提交")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/wx-img4.jpg"),
      "alt": "维修查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('5_1')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("一、发货单管理")]), _vm._v(" "), _c('p', [_vm._v("发货单管理：用户在合作库平台发出的发货申请指定全部展示在这里，支持适时查询平台的处理进度。")]), _vm._v(" "), _c('p', [_vm._v("(1)、点击“物流信息查询”选择“发货单列表”展示所有发货单的情况，可选择“待发货、和已发货”状态展示哪些发货单已发货或待发货，已发货的产品可从物流订单列表查询到产品的配送与抵达时间")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/wl-img1.jpg"),
      "alt": "物流查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('5_2')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("二、物流订单列表")]), _vm._v(" "), _c('p', [_vm._v("已授理的发货申请单在“物流订单列表”展示，支持用户适时查询物流配送进度与送达时间。")]), _vm._v(" "), _c('p', [_vm._v("(1)、点击“物流信息查询”选择“物流订单列表”展示所有已发货产品的物流配送状态，点击“查看”可展示单一产品物料配送的详细信息（图2）")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/wl-img2.jpg"),
      "alt": "物流查询"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/wl-img3.jpg"),
      "alt": "物流查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('6_1')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("一、委托收益报表")]), _vm._v(" "), _c('p', [_vm._v("委托收益报表是指委托合作库成功租赁后的结算收入展示。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/cw-img1.jpg"),
      "alt": "财务查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('6_2')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("二、委托销售报表")]), _vm._v(" "), _c('p', [_vm._v("委托销售报表是指委托合作库成功销售后的结算收入展示。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/cw-img2.jpg"),
      "alt": "财务查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('6_3')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("三、维修支出报表")]), _vm._v(" "), _c('p', [_vm._v("维修支出报表是指委托合作库维修并向合作库支出的费用。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/cw-img3.jpg"),
      "alt": "财务查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('6_4')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("四、物流支出报表")]), _vm._v(" "), _c('p', [_vm._v("物流支出报表是指委托合作库发货产生的物流支出的费用。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/cw-img4.jpg"),
      "alt": "财务查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('6_5')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("五、租赁支出报表")]), _vm._v(" "), _c('p', [_vm._v("租赁支出报表是指向合作库租赁配件所产生的支出费用，所有的租赁支出订单费用在这里展示查询。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/cw-img5.jpg"),
      "alt": "财务查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('6_6')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("六、保证金支出报表")]), _vm._v(" "), _c('p', [_vm._v("保证金支出报表是指用户用于租赁业务的押金，合作库临时保管，业务结束后会退回用户帐户，展示所有订单支出的保证金，也能输入单个订单查询详情。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/cw-img6.jpg"),
      "alt": "财务查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('6_7')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("七、代管支出报表")]), _vm._v(" "), _c('p', [_vm._v("代管支出报表是指委托合作库代为管理所产生的代管费用。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/cw-img7.jpg"),
      "alt": "财务查询"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('7_1')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("一、发货通知单")]), _vm._v(" "), _c('p', [_vm._v("(1)、发货通知单查询")]), _vm._v(" "), _c('p', [_vm._v("1>点击“订单管理”选择“发货通知单”即可展示所有发货通知单的状态，单一发货单或具体产品查询看需输入条件选项查询操作。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img1.jpg"),
      "alt": "订单管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("(2)、新建发货申请单只针对有租赁代管和自有代管业务的产品")]), _vm._v(" "), _c('p', [_vm._v("1>.点击“订单管理”选择“新建发货通知单”。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img2.jpg"),
      "alt": "订单管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("2>.选择要发货的产品，点击“加入发货”即可")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img3.jpg"),
      "alt": "订单管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("3>补充详细收货人电话地址，发货方式，如果需要发往不同地址，点击新增地址和新增产品，核对无误后点击提高，后台工作人员会接收发货申请并安排发货，必要时在发货前会与提前方进一步核实发货申请、收货人电话和地址等信息。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img4.jpg"),
      "alt": "订单管理"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('7_2')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("二、采购询价单")]), _vm._v(" "), _c('p', [_vm._v("所有采购询价单查询展示和新增采购询价单在这个界面操作，详情如下：")]), _vm._v(" "), _c('p', [_vm._v("(1)、采购询价单查询：")]), _vm._v(" "), _c('p', [_vm._v("1>.点击“订单管理”选择采购询价单，即可展示所有采购询价单的后台回复处理状态，或点击“查看”展示处理详情。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img5.jpg"),
      "alt": "订单管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("(2)、新建采购询价单")]), _vm._v(" "), _c('p', [_vm._v("1>.点击“订单管理”1>.有产品采购需求的，需提交采购询价单，点击“订单管理”选择“采购询价单”，或点击“库存查询”选择“委托库查询”均可进入采购询价页面。，即可展示所有采购询价单的后台回复处理状态，或点击“查看”展示处理详情。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img6.jpg"),
      "alt": "订单管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("2>.选择“委托总库”只售产品清单，选择要采购的产品，点击“加入询价”即加入到采购询价单列表。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img7.jpg"),
      "alt": "订单管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("3>.选好要采购的产品后，点击“采购询价单”核对采购的产品是否正确，无误后补充联系方式后点击提高，等待或致电后台工作人员回复您的采购信息。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img8.jpg"),
      "alt": "订单管理"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('7_3')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("三、委托申请单")]), _vm._v(" "), _c('p', [_vm._v("新增配件委托业务的在以下页面查询和新增申请，详细操作如下：")]), _vm._v(" "), _c('p', [_vm._v("(1)、委托申请单查询")]), _vm._v(" "), _c('p', [_vm._v("1>点击“订单管理”选择“委托申请单”即能查询所有委托申请单列表，也可点击“查看”了解单个产品的详细处理情况。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img9.jpg"),
      "alt": "订单管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("(2)、新建委托申请单")]), _vm._v(" "), _c('p', [_vm._v("1>.从订单管理下的委托申请或和从库存查询下的代管库查询均能执行“新建委托申请单”。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img10.jpg"),
      "alt": "订单管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("2>.委托申请暂只针对用户自有代管库的产品可线上操作，其它产品委托请直接联系客服，后续功能会增加直接上传功能。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img11.jpg"),
      "alt": "订单管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("3>.核对委托申请单的产品信息，选择委托时长（30.60.90.120.180.210天）、单价（委托的目标价）、委托类型（可租可售、只租、只售、代管），补充好相应信息后点击提交，后来工作人员会处理回复，提交的信息可在委托申请清单查询。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img12.jpg"),
      "alt": "订单管理"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('7_4')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("四、调度申请单")]), _vm._v(" "), _c('p', [_vm._v("合作库平台调度业务暂只针对代管产品，可申请发往任何地点，详细操作说明如下：")]), _vm._v(" "), _c('p', [_vm._v("(1)、调度申请单查询")]), _vm._v(" "), _c('p', [_vm._v("1>已申请的调度单查询，点击“订单管理”选择“调度申请单”即可查看所有的调度申请单，点击查看可展示调度单详情；")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img13.jpg"),
      "alt": "订单管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("(2)、新建调度申请单")]), _vm._v(" "), _c('p', [_vm._v("1>.点击“库存查询”选择“代管库查询”下的租赁和自有代管库的产品列表，选择需要调度的产品点击“加入调度”即可进入“调度申请单”。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img14.jpg"),
      "alt": "订单管理"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("2>核对调度申请单产品、数量，录入调度的地址信息，调度的备注要求。确认无误即可提高信息，待后台处理并回复。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/dd-img15.jpg"),
      "alt": "订单管理"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('8_1')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("一、公司信息")]), _vm._v(" "), _c('p', [_vm._v("(1)、公司的基础信息的录入与管理，包含总部与分部的信息，有增加的点击新增即可。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/gr-img1.jpg"),
      "alt": "个人中心"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("(2)、主要联系人的录入与管理：可以全部展示也可以查询展示，点击新增联系人可添加新的信息，通过编辑、分配帐户及权限、删除等管理联系人信息。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/gr-img2.jpg"),
      "alt": "个人中心"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-10"
  }, [_vm._v("(3)、帐户与权限设置：一个分部可设定一名主要责任人处理相应的事务。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/gr-img3.jpg"),
      "alt": "个人中心"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('8_2')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("二、服务网点信息")]), _vm._v(" "), _c('p', [_vm._v("(1)、服务网点的信息管理：可以修改网点或增加服务网点的信息资料，通过条件可快速查询某一网点的详细信息。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/gr-img4.jpg"),
      "alt": "个人中心"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('8_3')) ? _c('div', [_c('h4', {
    staticClass: "pt-10"
  }, [_vm._v("三、工程师信息")]), _vm._v(" "), _c('p', [_vm._v("(1)、工程师的信息管理：可以修改或增加工程师的信息资料，通过条件可快速查询某一网点的工程师信息。")]), _vm._v(" "), _c('div', {
    staticClass: "help-pd"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/gr-img5.jpg"),
      "alt": "个人中心"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.resultForm.includes('8_4')) ? _c('div', [_c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('h3', {
    staticClass: "inputFormH3"
  }, [_vm._v("感谢你为平台提供的宝贵建议，每一次反馈将让我们的服务做得更好！")]), _vm._v(" "), _c('el-form', {
    ref: "inputForm",
    attrs: {
      "model": _vm.inputForm,
      "label-width": "80px",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "text"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入反馈内容"
    },
    model: {
      value: (_vm.inputForm.text),
      callback: function($$v) {
        _vm.inputForm.text = $$v
      },
      expression: "inputForm.text"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("立即创建")])], 1)], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clear-fix help-wp5-bg help-right1"
  }, [_c('h3', {
    staticClass: "help-right1-title1"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "clear-fix help-kf help-kf-left"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../assets/help_icon9.jpg"),
      "alt": "phone"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "help-qq"
  }, [_c('a', {
    attrs: {
      "href": "http://wpa.qq.com/msgrd?v=3&uin=2850559846&site=qq&menu=yes",
      "target": "_blank"
    }
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-qq"
  }), _vm._v("在线客户")])], 1)])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "clear-fix help-kf"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../assets/help_icon10.jpg"),
      "alt": "phone"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "help-qq help-phone"
  }, [_vm._v("0755-82405890")])])])], 1)], 1)])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3273a4b9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Help/HelpListPage.vue
// module id = 717
// module chunks = 0